import React from "react";
import SeoLandingPage from "./SeoLandingPage";

const page = {
  title: "Limassol to Larnaca Airport Taxi | 24/7 Airport Transfers",
  description:
    "Reliable airport taxi transfers from Limassol to Larnaca Airport. Fixed prices, flight monitoring and 24/7 availability.",
  canonical: "https://limassolairporttaxi.com/limassol-to-larnaca-airport-taxi",
  breadcrumbs: [
    { label: "Home", to: "/" },
    { label: "Airport Transfers", to: "/cyprus-airport-transfers" },
    { label: "Limassol to Larnaca Airport Taxi" },
  ],
  h1: "Limassol to Larnaca Airport Taxi",
  heroText:
    "Book a private taxi from Limassol to Larnaca Airport with punctual pickup, clear route pricing, and fast confirmation by phone or WhatsApp.",
  snapshotLabel: "Guide price",
  snapshotValue: "From EUR70",
  snapshotText:
    "Direct airport transfer from Limassol hotels, homes, offices, marina, and tourist areas to Larnaca Airport departures.",
  overviewTitle: "Direct taxi transfers from Limassol to Larnaca Airport",
  overviewText:
    "This route is one of the most requested airport transfers in Cyprus. It is ideal for early flights, business travel, families with luggage, and visitors who want a simple door-to-door journey.",
  overviewCards: [
    {
      label: "Pickup",
      title: "From any Limassol address",
      text: "We collect passengers from hotels, apartments, villas, offices, the marina, old town, and nearby Limassol areas.",
    },
    {
      label: "Drop-off",
      title: "Larnaca Airport departures",
      text: "Your driver takes you directly to the correct airport terminal area with time planned around your flight.",
    },
    {
      label: "Booking",
      title: "Quick confirmation",
      text: "Send your date, time, pickup point, passengers, luggage, and flight number for a fast transfer response.",
    },
  ],
  whyTitle: "Why book your Larnaca Airport taxi with us",
  whyText:
    "Limassol Airport Taxi focuses on punctual airport runs, clean vehicles, professional communication, and stress-free pickup planning for departures.",
  whyItems: [
    "Private door-to-door transfer with no shared stops",
    "Useful pickup timing advice for flight departures",
    "Comfortable taxis for luggage, families, and business travelers",
    "Fast booking by phone or WhatsApp day and night",
  ],
  routesTitle: "Popular routes connected to Larnaca Airport",
  routesText:
    "Use these internal routes when comparing airport pickups, return transfers, or other taxi journeys across Cyprus.",
  popularRoutes: [
    {
      title: "Larnaca Airport Taxi",
      to: "/larnaca-airport-taxi",
      text: "Private airport taxi transfers between Limassol and Larnaca Airport with fixed price information.",
    },
    {
      title: "Larnaca Airport to Limassol",
      to: "/larnaca-airport-to-limassol",
      text: "Arrival transfer from Larnaca Airport to Limassol hotels, marina, apartments, and residential areas.",
    },
    {
      title: "Taxi Limassol",
      to: "/taxi-limassol",
      text: "Local and long-distance taxi service from Limassol for city rides, hotels, and airport transfers.",
    },
    {
      title: "Cyprus Airport Transfers",
      to: "/cyprus-airport-transfers",
      text: "Compare taxi transfer options for Larnaca Airport, Paphos Airport, Limassol, Nicosia, and resorts.",
    },
  ],
  infoTitle: "Larnaca Airport transfer details",
  infoText:
    "A private taxi gives you control over pickup time, luggage space, route, and drop-off point. For airport departures, we recommend booking ahead and allowing time for traffic, check-in, and security.",
  infoDetails: [
    ["Route", "Limassol to Larnaca Airport"],
    ["Service", "Private airport taxi"],
    ["Journey time", "Usually around 45 to 60 minutes"],
    ["Booking", "Phone or WhatsApp"],
    ["Availability", "24/7 by request"],
    ["Best for", "Departures, business trips, families, luggage"],
  ],
  availabilityTitle: "Early morning and late night Larnaca Airport taxis",
  availabilityText:
    "Flights do not always match normal working hours. You can request a Limassol to Larnaca Airport taxi for dawn departures, late evening flights, weekends, holidays, and urgent travel plans.",
  faqTitle: "Limassol to Larnaca Airport taxi FAQ",
  faqs: [
    {
      question: "How long does a taxi from Limassol to Larnaca Airport take?",
      answer:
        "The journey usually takes around 45 to 60 minutes, depending on traffic, pickup area in Limassol, and the time of day.",
    },
    {
      question: "How much is a taxi from Limassol to Larnaca Airport?",
      answer:
        "The guide price starts from EUR70 for a standard private transfer. Exact pricing can depend on pickup location, time, passengers, luggage, and special requests.",
    },
    {
      question: "Can I book a taxi for an early morning flight?",
      answer:
        "Yes. Airport taxis can be arranged 24/7, including very early departures from Limassol to Larnaca Airport.",
    },
    {
      question: "Should I pre-book my Larnaca Airport transfer?",
      answer:
        "Pre-booking is recommended, especially for early flights, holiday periods, family travel, or if you need extra luggage space.",
    },
    {
      question: "Can I send my flight details by WhatsApp?",
      answer:
        "Yes. WhatsApp is the easiest way to send your pickup address, flight time, passengers, luggage, and any special instructions.",
    },
  ],
};

export default function LimassolToLarnacaAirportPage() {
  return <SeoLandingPage page={page} />;
}
